"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PermissionLevelDisplay = void 0;
var React = __importStar(require("react"));
var react_1 = require("@chakra-ui/react");
var pro_regular_svg_icons_1 = require("@fortawesome/pro-regular-svg-icons");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var usePermissionLevelDisplayNames_1 = require("./usePermissionLevelDisplayNames");
var PermissionLevelDisplay = function (_a) {
    var permissionLevel = _a.permissionLevel, _b = _a.showIcon, showIcon = _b === void 0 ? false : _b;
    var permissionLevelDisplayNames = (0, usePermissionLevelDisplayNames_1.usePermissionLevelDisplayNames)();
    return (React.createElement(react_1.Stack, { direction: "row", spacing: 2, align: "center", opacity: 0.5, px: 4 },
        React.createElement(react_1.Box, { as: "span" }, permissionLevelDisplayNames[permissionLevel]),
        showIcon && React.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_regular_svg_icons_1.faLockKeyhole })));
};
exports.PermissionLevelDisplay = PermissionLevelDisplay;
